import { useNavigate } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH } from "../../constants/env";
import { MainLogo } from "../ui/display/bonusx-logo/main-logo";
import { WrapperLogo } from "../ui/display/bonusx-logo/wrapper-logo";

export const LOGO_ID = "bonusx-logo-id";

export interface BonusXLogoProps {
  onClick?: Function;
  forceLogoExtended?: boolean;
  isClickable?: boolean;
}

export function BonusXLogo({ onClick, forceLogoExtended, isClickable = true }: Readonly<BonusXLogoProps>): JSX.Element {
  const navigate = useNavigate();

  return (
    <WrapperLogo id={LOGO_ID} onClick={() => whenLogoIsClicked()}>
      <MainLogo forceLogoExtended={forceLogoExtended} />
    </WrapperLogo>
  );

  function whenLogoIsClicked() {
    if (!isClickable) {
      return;
    }
    const hasOnClickOverride = onClick && typeof onClick === "function";
    if (hasOnClickOverride) {
      return onClick();
    }

    navigate(LOGGED_HOME_PAGE_PATH);
  }
}
